import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';
import { convertToFormData } from '../utils/helpers';

export const types = {
  SET_JOB: 'SET_JOB',
  ...addAsyncActionPostfixes({
    FETCH_JOB: 'FETCH_JOB',
    FETCH_JOBS: 'FETCH_JOBS',
    FETCH_SAVED_JOBS: 'FETCH_SAVED_JOBS',
    FETCH_APPLIED_JOBS: 'FETCH_APPLIED_JOBS',
    FETCH_JOBS_PUBLIC: 'FETCH_JOBS_PUBLIC',
    FETCH_RECOMENDED_JOBS: 'FETCH_RECOMENDED_JOBS',
    SAVE_JOB: 'SAVE_JOB',
    REMOVE_SAVED_JOB: 'REMOVE_SAVED_JOB',
    APPLY_JOB: 'APPLY_JOB',
    APPLY_JOB_V2: 'APPLY_JOB_V2',
    CHANGE_PAGE: 'CHANGE_PAGE',
    GET_COUNTERS: 'GET_COUNTERS',
    SET_APPLIED_JOB: 'SET_APPLIED_JOB',
    FETCH_PUBLIC_JOB: 'FETCH_PUBLIC_JOB'
  })
};

const preparePartOfURI = (key, arrayOfValues) => {
  return arrayOfValues.reduce((result, value) => `${result}${key}=${encodeURIComponent(value)}&`, '');
};

function fields(page, search, filterPeriods) {
  let text = `PageNumber=${page.active || page.PageNumber}&`;
  text += `PageSize=${page.limit || page.PageSize}&`;
  text += search.field ? `Field=${encodeURIComponent(search.field)}&` : '';
  text += search.location ? `Location=${encodeURIComponent(search.location)}&` : '';
  text += search?.industry?.length ? preparePartOfURI('Industry', search.industry) : '';
  text += search?.function?.length ? preparePartOfURI('JobFunction', search.function) : '';
  text += search?.contract_type?.length ? preparePartOfURI('Contract_Type', search.contract_type) : '';
  text += search?.date_posted?.length
    ? preparePartOfURI(
        'Date_Posted_Days',
        search.date_posted.map((value) => filterPeriods.find((item) => item.label === value).value)
      )
    : '';

  return text;
}

export const getCounters = createAsyncAction(types.GET_COUNTERS, () =>
  api.get(`v1/job/job-count`).then((res) => res.data)
);

export const fetchJobs = createAsyncAction(types.FETCH_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchSavedJobs = createAsyncAction(types.FETCH_SAVED_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/job/saved-jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchAppliedJobs = createAsyncAction(types.FETCH_APPLIED_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/job-applications?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchJobsPublic = createAsyncAction(types.FETCH_JOBS_PUBLIC, (page, search, filterPeriods) =>
  api.get(`v1/job/public-jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchJob = createAsyncAction(types.FETCH_JOB, (referenceId) =>
  api.get(`v1/job/${referenceId}`).then((res) => res.data)
);

export const fetchPublicJob = createAsyncAction(types.FETCH_PUBLIC_JOB, (referenceId) =>
  api.get(`v1/job/public-job/${referenceId}`).then((res) => res.data)
);

export const setJob = createAction(types.SET_JOB, (job) => job);

// TODO: uri should be replaced
export const fetchRecommendedJobs = createAsyncAction(types.FETCH_RECOMENDED_JOBS, () =>
  api.get(`v1/job/recommendations?PageNumber=1&PageSize=3`).then((res) => res.data)
);

export const saveJob = createAsyncAction(types.SAVE_JOB, (id, userId) =>
  api.post(`v1/job/save-job`, { JobId: id, UserId: userId }).then((res) => ({ ...res.data, jobId: id }))
);

export const removeSavedJob = createAsyncAction(types.REMOVE_SAVED_JOB, (id) =>
  api.delete(`v1/job/remove-saved-job?jobId=${id}`).then((res) => ({ ...res.data, jobId: id }))
);

export const applyJob = createAsyncAction(
  types.APPLY_JOB,
  (
    job = {
      JobId: 0,
      UserId: 0,
      Answer1: '',
      Answer2: '',
      Answer3: ''
    }
  ) => api.post(`v1/job-application`, job).then((res) => res.data)
);

export const changePage = (page) => ({
  type: types.CHANGE_PAGE,
  payload: page
});

export const setAppliedJob = createAction(types.SET_APPLIED_JOB, (payload) => payload);

export const applyJobv2 = createAsyncAction(types.APPLY_JOB_V2, (data) => {
  const formDataBody = convertToFormData(data);
  return api.post(`/v1/quick-job-application`, formDataBody).then((res) => res?.data);
});
